import Recipe from 'records/Recipe';
import Base from 'records/Base';

import {
  BATCH_RECIPE_ASYNC_ACTION_START,
  BATCH_RECIPE_ASYNC_ACTION_ERROR,
  BATCH_RECIPE_ASYNC_UPDATE_ACTION_SUCCESS,
  BATCH_RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS,
  BATCH_RECIPE_ASYNC_RESTORE_ACTION_SUCCESS,
  BATCH_RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS,
  BATCH_RECIPE_UPDATE_ACTION_SUCCESS,
  BATCH_RECIPE_RESET_STATE,
  BATCH_RECIPE_ASYNC_DELETE_ACTION_SUCCESS,
  BATCH_RECIPE_ACTION_SUCCESS,
} from 'actions/batchrecipe';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Recipe(),
});

const actionsMap = {
  [BATCH_RECIPE_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [BATCH_RECIPE_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [BATCH_RECIPE_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Recipe(action.data),
    });
  },
  [BATCH_RECIPE_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new Base({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  // only merge selected attributes
  [BATCH_RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS]: (state, action) => {
    const originalRecipe = state.data;
    const newRecipe = originalRecipe.merge({
      ...action.data,
    });
    return new Base({
      loading: false,
      errorMessage: null,
      data: newRecipe,
    });
  },
  [BATCH_RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [BATCH_RECIPE_ASYNC_RESTORE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [BATCH_RECIPE_ASYNC_DELETE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [BATCH_RECIPE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [BATCH_RECIPE_RESET_STATE]: () => {
    return initialState;
  },
};

export default function batchrecipe(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
